// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/participation_request.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_planners_v1_resources_participation_request_state } from "./participation_request_state_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/participation_request.proto.
 */
export const file_studyo_today_planners_v1_resources_participation_request = /*@__PURE__*/
  fileDesc("Cj5zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BhcnRpY2lwYXRpb25fcmVxdWVzdC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyLvAQoUUGFydGljaXBhdGlvblJlcXVlc3QSGgoScGFydGljaXBhdGlvbl9jb2RlGAEgASgJEjIKDnJlcXVlc3RlZF90aW1lGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBJMCgVzdGF0ZRgDIAEoDjI9LnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuUGFydGljaXBhdGlvblJlcXVlc3RTdGF0ZRIZChFyZXF1ZXN0ZXJfdXNlcl9pZBgEIAEoCRIeChZyZXF1ZXN0ZXJfZGlzcGxheV9uYW1lGAUgASgJQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_protobuf_timestamp, file_studyo_today_planners_v1_resources_participation_request_state]);

/**
 * Describes the message studyo.today.planners.v1.resources.ParticipationRequest.
 * Use `create(ParticipationRequestSchema)` to create a new message.
 */
export const ParticipationRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_participation_request, 0);

